import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import {styled} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import {React, useState} from 'react';
import {useSelector} from 'react-redux';

import CustomToast from '../../components/CustomToast/CustomToast';
import {ConfigConstant} from '../../constants/config';
import {AppIcon, LogOutIcon} from '../../constants/icons';
import {pxToRem} from '../../utils';
import {logOutUser} from '../../utils/helper';

const StyledDivider = styled('span')(({theme}) => ({
  borderLeft: `${pxToRem(0.5)} solid ${theme.palette.grey[400]}`,
  marginTop: theme.spacing(1),
  marginRight: theme.spacing(0.5),
  height: pxToRem(25),
}));

function Header() {
  const user = useSelector((state) => state.auth);
  const [open, setOpen] = useState(false);

  const handleRoute = () => {
    window.location.href = ConfigConstant.COMMON_ROUTE;
  };

  const handleLogOutClick = () => {
    setOpen(true);
  };

  const handleLogOutClose = () => {
    setOpen(false);
  };

  const onLogOut = async () => {
    logOutUser();
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: (theme) => theme.palette.white,
        boxShadow: (theme) => theme.palette.boxShadow.type2,
        height: pxToRem(40),
        marginBottom: pxToRem(-13),
        zIndex: 10,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          marginRight: (theme) => theme.spacing(2),
          marginLeft: 'auto',
          marginTop: (theme) => theme.spacing(1),
          marginBottom: (theme) => theme.spacing(1),
        }}
      >
        <Typography
          sx={{
            marginLeft: (theme) => theme.spacing(2),
            marginRight: (theme) => theme.spacing(2),
            color: (theme) => theme.palette.black,
            fontSize: pxToRem(14),
            fontWeight: pxToRem(2),
            marginTop: (theme) => theme.spacing(-1),
          }}
        >
          Hi {user?.name}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            marginTop: (theme) => theme.spacing(-1),
          }}
        >
          <StyledDivider />
          <IconButton
            sx={{
              marginRight: (theme) => theme.spacing(-1),
              padding: pxToRem(12),
            }}
            onClick={handleRoute}
          >
            <AppIcon />
          </IconButton>
          <IconButton
            onClick={handleLogOutClick}
            sx={{
              marginRight: (theme) => theme.spacing(-1.5),
              padding: pxToRem(12),
            }}
          >
            <LogOutIcon />
          </IconButton>
          <CustomToast
            message={`Are you sure you want to Logout?`}
            isOpen={open}
            onHandleSubmit={onLogOut}
            onHandleClose={handleLogOutClose}
            Icon={LogOutIcon}
          />
        </Box>
      </Box>
    </AppBar>
  );
}

export default Header;
